import { commandApi } from './commandApi';

const GET_SCHOOL_OBJECTIVES_COMMAND = 'get-school-objectives';
const SET_PARENT_OBJECTIVES_VISIBILITY_SETTING = '2bap:set-parent-objectives-visibility-setting';
const SET_NEXT_STEP_OBJECTIVES_VISIBILITY_SETTING = '2bap:set-next-step-objectives-visibility-setting';


class ObjectivesApi {

  async getSchoolObjectives(paging) {
    return commandApi.send(GET_SCHOOL_OBJECTIVES_COMMAND, paging);
  }

  async setParentObjectivesVisibilitySetting(schoolId, settingValue) {
    return commandApi.send(SET_PARENT_OBJECTIVES_VISIBILITY_SETTING, { schoolId, settingValue });
  }

  async setNextStepObjectivesVisibilitySetting(schoolId, settingValue) {
    return commandApi.send(SET_NEXT_STEP_OBJECTIVES_VISIBILITY_SETTING, { schoolId, settingValue });
  }

}

export const objectivesApi = new ObjectivesApi();
